import styled from 'styled-components'
import InputMask from 'react-input-mask'
import globals from '../globals'
import { lighten, darken } from 'polished'

export const InputField = styled.input`
  width:100%;
  display:block;
  line-height: ${globals.inputs.lineHeight.normal};
  border:1px solid ${globals.colors.lightblue};
  border-radius:3px;
  margin:0;
  padding-left: 13px;
  padding-right: 13px;
  transition: all .2s;

  &:focus {
    outline:none;
    border-color: ${darken(0.15, globals.colors.lightblue)};
  }

  &:hover {
    border-color: ${lighten(0.2, globals.colors.lightblue)};
  }

  &:active {
    outline:none;
  }
`

export const InputMaskField = styled(InputMask)`
  width:100%;
  display:block;
  line-height: ${globals.inputs.lineHeight.normal};
  border:1px solid ${globals.colors.lightblue};
  border-radius:3px;
  margin:0;
  padding-left: 13px;
  padding-right: 13px;
  transition: all .2s;

  &:focus {
    outline:none;
    border-color: ${darken(0.15, globals.colors.lightblue)};
  }

  &:hover {
    border-color: ${lighten(0.2, globals.colors.lightblue)};
  }

  &:active {
    outline:none;
  }
`

export const TextAreaField = styled.textarea`
  width:100%;
  height:auto;
  display:block;
  border-radius:3px;
  line-height: 1.6;
  border:1px solid ${globals.colors.lightblue};
  margin: 0;
  padding: 15px;
  overflow-x: hidden;
  resize: vertical;

  &:focus {
    outline:none;
    border-color: ${darken(0.15, globals.colors.lightblue)};
  }

  &:hover {
    border-color: ${lighten(0.2, globals.colors.lightblue)};
  }

  &:active {
    outline:none;
  }
`

export const LabelField = styled.label`
  display: block;
  font-weight:300;
  padding-bottom:4px;
`

export const Error = styled.div`
  display:block;
  font-weight:bold;
  padding-top:5px;
  font-size:85%;
  color: ${globals.colors.red};
`